import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Modal, Input, Select, Textarea, Btn } from "@/components/UI";
import { PRICE_FIELDS, CURRENCIES, EMPTY_PRODUCT } from "@/lib/products";
import { apiError } from "@/lib/customers";

const NUM_KEYS = ["purchase_price", "critical_stock", ...PRICE_FIELDS.map((p) => p.key)];

export function ProductFormModal({ open, product, onClose, onSaved }) {
  const [f, setF] = useState(EMPTY_PRODUCT);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setF({ ...EMPTY_PRODUCT, ...(product || {}) }); setErr(""); } }, [open, product]);
  const set = (k) => (e) => { setErr(""); setF({ ...f, [k]: e.target.value }); };

  const save = async () => {
    if (!String(f.name).trim()) return setErr("Ürün adı zorunludur");
    const payload = { ...f };
    for (const k of NUM_KEYS) {
      const n = Number(payload[k] === "" ? 0 : payload[k]);
      if (Number.isNaN(n) || n < 0) return setErr("Fiyat ve kritik stok 0 veya pozitif sayı olmalıdır");
      payload[k] = n;
    }
    setBusy(true);
    try {
      const saved = product ? await api.put(`/products/${product.id}`, payload) : await api.post("/products", payload);
      onSaved(saved);
    } catch (e) { setErr(apiError(e, "Kaydedilemedi")); }
    finally { setBusy(false); }
  };

  return (
    <Modal open={open} onClose={onClose} title={product ? "Ürün Kartını Düzenle" : "Yeni Ürün"} size="lg">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="product-form">
        <Input label="Ürün Kodu" placeholder="Boş bırakılırsa otomatik (PRD-00001)" value={f.code || ""} onChange={set("code")} data-testid="prod-form-code" />
        <Input label="Ürün Adı *" value={f.name} onChange={set("name")} data-testid="prod-form-name" />
        <div className="sm:col-span-2"><Textarea label="Açıklama / Özellik" value={f.description || ""} onChange={set("description")} data-testid="prod-form-description" /></div>
        <Input label="Alış Fiyatı" type="number" min="0" step="0.01" value={f.purchase_price} onChange={set("purchase_price")} data-testid="prod-form-purchase-price" />
        <Select label="Alış Para Birimi" value={f.purchase_currency} onChange={set("purchase_currency")} data-testid="prod-form-currency">
          {CURRENCIES.map((c) => <option key={c} value={c}>{c}</option>)}
        </Select>
        {PRICE_FIELDS.map((p) => (
          <Input key={p.key} label={`${p.label} (TRY)`} type="number" min="0" step="0.01" value={f[p.key]} onChange={set(p.key)} data-testid={`prod-form-${p.key}`} />
        ))}
        <Input label="Kritik Stok Seviyesi" type="number" min="0" value={f.critical_stock} onChange={set("critical_stock")} data-testid="prod-form-critical" />
        <Select label="Durum" value={f.active ? "1" : "0"} onChange={(e) => setF({ ...f, active: e.target.value === "1" })} data-testid="prod-form-active">
          <option value="1">Aktif</option><option value="0">Pasif</option>
        </Select>
      </div>
      {err && <div className="mt-3 text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-md px-3 py-2" data-testid="prod-form-error">{err}</div>}
      <div className="flex justify-end gap-2 mt-4">
        <Btn variant="secondary" onClick={onClose} data-testid="prod-form-cancel">Vazgeç</Btn>
        <Btn onClick={save} disabled={busy} data-testid="prod-form-save">{busy ? "Kaydediliyor…" : "Kaydet"}</Btn>
      </div>
    </Modal>
  );
}
